import { render, staticRenderFns } from "./CreditsHideIcon.vue?vue&type=template&id=5fbb3fe6&"
import script from "./CreditsHideIcon.vue?vue&type=script&lang=js&"
export * from "./CreditsHideIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports